import { cn } from "@/lib/utils";

export default function ButtonGhost({ children, onClick, type = "button", disabled, className = "", full = false }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-lg border border-brand-line bg-white px-5 py-2.5 text-sm font-semibold text-brand-ink transition-colors duration-150 hover:border-brand-ink disabled:cursor-not-allowed disabled:opacity-50",
        full && "w-full",
        className
      )}
    >
      {children}
    </button>
  );
}
